import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import EmailSentIcon from '../../../icons/components/EmailSentIcon';
import CommonButton from '../../../components/common-button/CommonButton';

import scss from '../AdImagesRequest.module.scss';

function EmailSent() {
  const { t } = useTranslation('securityPage');
  const navigate = useNavigate();

  const handleRedirectToHome = () => {
    navigate('/ad/images/demo');
  };

  return (
    <div className={scss.form}>
      <EmailSentIcon className={scss.emailSentIcon} />

      <h1 className={scss.title}>{t('emailWasSent')}</h1>

      <div className={scss.items}>
        <h4 className={scss.subtitle}>{t('checkEmail')}</h4>
      </div>

      <div className={scss.buttons}>
        <CommonButton styleColor='primary' maxWidth={190} onClick={handleRedirectToHome}>
          {t('gotIt')}
        </CommonButton>
      </div>
    </div>
  );
}

export default EmailSent;
